import { nextTick, ref, watch } from "@vue/composition-api";

import { makeHistory } from "@/utils/history";
import { Item } from "@/tools/msa/models/item";
import { waitTicks } from "@/tools/msa/utils/ticks";

const extractItems = (items: Item[], types: string[]) =>
  items.filter(item => types.includes(item.type));

const useHistory = (props: any) => {
  const types: string[] = ["code_match", "custom_match", "msa_custom"];

  const history = makeHistory(extractItems(props.document.items, types));

  const mutex = ref(false);

  watch(
    () => history.state.value.current,
    async () => {
      if (
        history.state.value.past.length === 0 &&
        history.state.value.future.length === 0
      )
        return;
      mutex.value = true;
      props.document.items = [
        ...props.document.items.filter(
          (item: Item) => !types.includes(item.type)
        ),
        ...history.state.value.current
      ];
      await waitTicks(1);
      mutex.value = false;
    }
  );

  watch(
    () => props.document.items,
    () => {
      if (mutex.value) return;
      history.reset(extractItems(props.document.items, types));
    }
  );

  return { history };
};

export default useHistory;
